import type { MessageDescriptor } from 'react-intl';
import { isPlainObject } from 'es-toolkit';
import { isValidElement } from 'react';
import { useIntl } from 'react-intl';

interface FormattedErrorProps {
  error: React.ReactNode | MessageDescriptor | undefined;
}

export function FormattedError({ error }: FormattedErrorProps) {
  const intl = useIntl();

  if (!isValidElement(error) && isI18nMessageDescriptor(error)) {
    return <>{intl.formatMessage(error)}</>;
  }

  return error;
}

function isI18nMessageDescriptor(value: unknown): value is MessageDescriptor {
  return isPlainObject(value) && 'id' in value && 'defaultMessage' in value;
}
